import React from "react";
import { MapPin, Phone, Mail, Clock } from "lucide-react";
import Slider from "react-slick"; // 👈 npm install react-slick slick-carousel
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default function LandingAnalizar() {
  const equipo = [
    {
      nombre: "Dra. Karina Angarita",
      cargo: "Directora Técnica",
      foto: "/equipo/karina.jpeg",
    },
    {
      nombre: "Ingrid Gutierrez",
      cargo: "Analista",
      foto: "/equipo/ingrid.jpeg",
    },
    {
      nombre: "Paola Parra",
      cargo: "Coordinadora de calidad",
      foto: "/equipo/paola.jpeg",
    },
    {
      nombre: "Alexis Esteban",
      cargo: "Apoyo logístico",
      foto: "/equipo/alexis.jpeg",
    },
  ];

  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 768, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <div className="font-sans text-gray-800 bg-white">
      {/* Header con logo */}
      <header className="fixed top-0 left-0 w-full bg-white shadow-md z-50 flex items-center justify-between px-6 py-3">
        <div className="flex items-center space-x-3">
          <img
            src="/logo-analizar.jpeg"
            alt="Logo Analizar Veterinario"
            className="h-12 w-auto"
          />
        </div>
        <nav className="hidden md:flex space-x-6 text-gray-700 font-medium">
          <a href="#servicios" className="hover:text-purple-700">
            Servicios
          </a>
          <a href="#equipo" className="hover:text-purple-700">
            Equipo
          </a>
          <a href="#contacto" className="hover:text-purple-700">
            Contacto
          </a>
          <a href="/login" className="hover:text-purple-700">
            Resultados
          </a>
          <a href="/login" className="hover:text-purple-700">
            Solicitudes
          </a>
        </nav>
      </header>

      {/* Hero con fondo */}
      <section
        className="relative text-white text-center pt-80 pb-32 px-6"
        style={{
          backgroundImage: "url('/fondo-laboratorio.png')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="absolute inset-0 bg-purple-900 bg-opacity-60"></div>
        <div className="relative z-10">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            Bienvenido a Analizar Veterinario
          </h1>
          <p className="max-w-2xl mx-auto text-lg opacity-90 mb-6">
            Servicios de diagnóstico clínico veterinario para pequeñas, grandes
            especies y animales silvestres. <br />
            <span className="font-semibold">
              Autorización ICA Nº LB0000052021
            </span>
          </p>
          <a
            href="#servicios"
            className="bg-white text-purple-700 px-6 py-3 rounded-full font-semibold hover:bg-purple-100 transition"
          >
            Conoce nuestros servicios
          </a>
        </div>
      </section>

      {/* Servicios */}
      <section id="servicios" className="py-16 px-6 bg-gray-50">
        <h2 className="text-3xl font-bold text-center text-purple-700 mb-10">
          Nuestros Servicios
        </h2>

        <div className="grid md:grid-cols-3 gap-8">
          {[
            {
              title: "Entrega de material",
              desc: "Suministro gratuito del material para la toma de muestras, solicitado por teléfono o correo electrónico.",
            },
            {
              title: "Recogida de muestra a domicilio",
              desc: "Servicio gratuito de recolección de muestras dentro del horario de recepción.",
            },
            {
              title: "Laboratorio de urgencias",
              desc: "Exámenes prioritarios con resultados en menos de una hora para la integridad del paciente.",
            },
            {
              title: "Exámenes de rutina y control",
              desc: "Análisis de diagnóstico general y seguimiento de tratamientos veterinarios.",
            },
            {
              title: "Exámenes especializados y de referencia",
              desc: "Procedimientos como ELISA, IFA y Quimioluminiscencia con tiempos de entrega entre 3 y 15 días.",
            },
          ].map((s, i) => (
            <div
              key={i}
              className="bg-white rounded-2xl shadow-md p-6 hover:shadow-lg transition"
            >
              <h3 className="text-xl font-semibold text-purple-700 mb-3">
                {s.title}
              </h3>
              <p className="text-gray-600">{s.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Beneficios */}
      <section className="py-16 px-6">
        <h2 className="text-3xl font-bold text-center text-purple-700 mb-10">
          Beneficios para nuestros clientes
        </h2>
        <div className="grid md:grid-cols-3 gap-8 text-center">
          <div>
            <h3 className="text-xl font-semibold text-purple-700 mb-2">
              Manejo y Recolección de Muestras
            </h3>
            <p>Entrega gratuita del material y formatos de análisis.</p>
          </div>
          <div>
            <h3 className="text-xl font-semibold text-purple-700 mb-2">
              Descuentos Especiales
            </h3>
            <p>10% de descuento en órdenes con cuatro o más exámenes.</p>
          </div>
          <div>
            <h3 className="text-xl font-semibold text-purple-700 mb-2">
              Entrega de Resultados
            </h3>
            <p>Recibe los resultados por correo electrónico o WhatsApp.</p>
          </div>
        </div>
      </section>

      {/* Política de calidad */}
      <section className="bg-purple-50 py-16 px-6">
        <h2 className="text-3xl font-bold text-center text-purple-700 mb-8">
          Política de Calidad
        </h2>
        <p className="max-w-4xl mx-auto text-center text-gray-700 leading-relaxed">
          Nuestro Sistema de Calidad garantiza resultados confiables, exactos y
          precisos en el tiempo justo. Cumplimos con la norma ISO/IEC 17025 y
          aplicamos buenas prácticas profesionales con un equipo técnico
          competente y comprometido.
        </p>
      </section>

      {/* Nuestro Equipo con carrusel */}
      <section id="equipo" className="py-20 px-4 sm:px-6 bg-purple-50">
        <h2 className="text-3xl font-bold text-center text-purple-700 mb-10">
          Nuestro Equipo
        </h2>

        <div className="max-w-6xl mx-auto w-full overflow-hidden">
          <Slider {...settings}>
            {equipo.map((persona, i) => (
              <div key={i} className="px-2 sm:px-4">
                <div className="bg-white rounded-2xl shadow-md p-6 text-center transform hover:scale-[1.02] transition">
                  <img
                    src={persona.foto}
                    alt={persona.nombre}
                    className="w-36 h-36 sm:w-44 sm:h-44 mx-auto rounded-full object-cover mb-4 border-4 border-purple-200"
                  />
                  <h3 className="text-lg sm:text-xl font-semibold text-purple-700">
                    {persona.nombre}
                  </h3>
                  <p className="text-sm sm:text-base text-gray-600">
                    {persona.cargo}
                  </p>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </section>

      {/* Institucional */}
      <section className="bg-gray-50 py-16 px-6">
        <h2 className="text-3xl font-bold text-center text-purple-700 mb-10">
          Institucional
        </h2>
        <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto text-center">
          <div>
            <h3 className="text-xl font-semibold text-purple-700 mb-3">
              Misión
            </h3>
            <p>
              Brindar un servicio integral y confiable, aplicando ciencia y
              tecnología con la más alta calidad y precisión en cada análisis.
            </p>
          </div>
          <div>
            <h3 className="text-xl font-semibold text-purple-700 mb-3">
              Visión
            </h3>
            <p>
              Ser reconocidos como el laboratorio clínico veterinario número uno
              del Norte de Santander, con honestidad, calidad y mejora continua.
            </p>
          </div>
          <div>
            <h3 className="text-xl font-semibold text-purple-700 mb-3">
              Valores
            </h3>
            <ul className="space-y-1">
              <li>• Calidad</li>
              <li>• Honestidad</li>
              <li>• Confianza</li>
              <li>• Eficiencia</li>
              <li>• Mejoramiento continuo</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Horarios y contacto */}
      <section id="contacto" className="py-16 px-6 text-center">
        <h2 className="text-3xl font-bold text-purple-700 mb-8">
          Horario de Atención y Contacto
        </h2>
        <div className="max-w-3xl mx-auto text-gray-700 mb-8">
          <div className="bg-purple-100 rounded-xl p-6 inline-block mb-6">
            <Clock className="mx-auto mb-3 text-purple-700" />
            <p>
              <strong>Lunes a viernes:</strong> 8:00 am – 6:00 pm <br />
              <strong>Sábados:</strong> 8:00 am – 6:00 pm <br />
              <strong>Domingos y festivos:</strong> 8:00 am – 12:00 m
            </p>
          </div>
          <div className="flex flex-col md:flex-row items-center justify-center gap-6 text-gray-700">
            <div className="flex items-center gap-2">
              <MapPin className="text-purple-700" />{" "}
              <span>
                Cl. 3 #7-70, Quinta Oriental, Cúcuta, Norte de Santander
              </span>
            </div>
            <div className="flex items-center gap-2">
              <Phone className="text-purple-700" /> <span>300 2211346</span>
            </div>
            <div className="flex items-center gap-2">
              <Mail className="text-purple-700" />{" "}
              <span>analizarvet@gmail.com</span>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-purple-800 text-white py-6 text-center">
        <p>
          © {new Date().getFullYear()} Analizar Veterinario — Desarrollado con{" "}
          <span className="text-purple-300 font-semibold">Vetronix</span>
        </p>
      </footer>
    </div>
  );
}
